<script>
export default {
  props: {
    label:  { type: String, default: 'Selecionar arquivo' },
    accept: { type: String, default: '*' },
    value:  { type: String, default: '' },
    hint:   { type: String, default: '' },
    maxMb:  { type: Number, default: 10 },
  },
  data() {
    return { dragging: false }
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      this.validarEmitir(file)
      e.target.value = ''
    },
    onDrop(e) {
      this.dragging = false
      const file = e.dataTransfer.files[0]
      if (!file) return
      this.validarEmitir(file)
    },
    validarEmitir(file) {
      if (file.size > this.maxMb * 1024 * 1024) {
        this.$toast.error(`Arquivo muito grande. Máximo ${this.maxMb}MB.`)
        return
      }
      this.$emit('change', file)
    },
    remover() {
      this.$emit('remover')
    },
    abrir() {
      if (!this.value) this.$refs.input.click()
    },
  },
}
</script>

<template>
  <div
    class="upload-zone"
    :class="{
      'upload-zone--filled':  !!value,
      'upload-zone--dragging': dragging && !value,
    }"
    @click="abrir"
    @dragover.prevent="dragging = true"
    @dragleave.prevent="dragging = false"
    @drop.prevent="onDrop"
  >
    <input ref="input" type="file" :accept="accept" class="upload-zone__input" @change="onFileChange" />

    <div v-if="!value" class="upload-zone__empty">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M12 16V4m0 0L7 9m5-5l5 5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 18v2a2 2 0 002 2h10a2 2 0 002-2v-2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p class="upload-zone__title">{{ label }}</p>
      <p v-if="hint" class="upload-zone__hint">{{ hint }}</p>
    </div>

    <div v-else class="upload-zone__filled-content" @click.stop>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
        <path d="M14 2v6h6M9 13h6M9 17h6M9 9h2"/>
      </svg>
      <span class="upload-zone__filename" :title="value">{{ value }}</span>
      <button type="button" class="upload-zone__remove" @click.stop="remover" aria-label="Remover arquivo">
        Remover
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "~@/design/tokens";

.upload-zone {
  border: 2px dashed $border-input;
  border-radius: $radius-input;
  background: transparent;
  padding: $space-5 $space-4;
  text-align: center;
  cursor: pointer;
  transition: all .15s;
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-zone--dragging {
  border-color: $brand-primary;
  background: $brand-primary-soft;
}

.upload-zone--filled {
  border-style: solid;
  border-color: $success;
  background: $success-soft;
  cursor: default;
  text-align: left;
  justify-content: flex-start;
}

.upload-zone__input { display: none; }

.upload-zone__empty {
  color: $text-muted;
}
.upload-zone__empty svg { color: $text-muted; margin-bottom: $space-2; }

.upload-zone__title {
  font-weight: 600;
  color: $text-strong;
  font-size: .95rem;
  margin: 0 0 $space-1;
}

.upload-zone__hint {
  font-size: .8rem;
  color: $text-muted;
  margin: 0;
}
.upload-zone__hint + .upload-zone__hint { margin-top: 2px; }

.upload-zone__filled-content {
  display: flex;
  align-items: center;
  width: 100%;
  gap: $space-3;
  color: $success;
}

.upload-zone__filename {
  flex: 1;
  font-size: .9rem;
  font-weight: 600;
  color: $text-strong;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-zone__remove {
  border: 0;
  background: $danger-soft;
  color: $danger;
  font-weight: 600;
  font-size: .85rem;
  padding: 6px 12px;
  border-radius: $radius-input;
  cursor: pointer;
  flex-shrink: 0;
}
.upload-zone__remove:hover { background: darken($danger-soft, 5%); }
</style>
